import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import safeHtml from "../../utils/safeHtml";
import fetchJsonWithFallback from "../../utils/fetchJsonWithFallback";
import { CDN_INCLUDES, CDN_ASSETS } from "../../utils/cdn";
import localAboutUs from "../../data/aboutUs.json";
import "./index.css";

function AboutUs() {
  const [aboutUs, setAboutUs] = useState(localAboutUs);

  useEffect(() => {
    let isMounted = true;
    fetchJsonWithFallback(CDN_INCLUDES + "aboutUs.json", localAboutUs).then((data) => {
      if (isMounted) setAboutUs(data);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const { heading, paragraphs } = aboutUs;

  return (
    <React.Fragment>
      <Container className="about-section">
        <Row className="align-items-center g-5">
          <Col xs={12} lg={7} className="about-content">
            {/* The "About Us" tagline is already rendered by the global hero (UpperHead);
                this heading is kept for document structure / accessibility only. */}
            <h2 className="sr-only">{safeHtml(heading)}</h2>
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{safeHtml(paragraph)}</p>
            ))}
          </Col>
          <Col xs={12} lg={5} className="about-photo">
            <img
              src={CDN_ASSETS + "about-family-photo1.webp"}
              alt="Family relaxing together in their rental home"
            />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default AboutUs;
